module.exports = __webpack_public_path__ + "media/images/samples/1280x768/7-6e5be628815eef27a482be514cae8a13.jpg";